/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Chat_EmptyInputs */

const en_us2_clubs_chat_empty = /** @type {(inputs: Clubs_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No messages yet.`)
};

const pt_br2_clubs_chat_empty = /** @type {(inputs: Clubs_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma mensagem ainda.`)
};

const es_419_clubs_chat_empty = /** @type {(inputs: Clubs_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay mensajes.`)
};

const pt_pt2_clubs_chat_empty = /** @type {(inputs: Clubs_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há mensagens.`)
};

const fr_fr2_clubs_chat_empty = /** @type {(inputs: Clubs_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun message pour l'instant.`)
};

const de_de2_clubs_chat_empty = /** @type {(inputs: Clubs_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Nachrichten.`)
};

const it_it2_clubs_chat_empty = /** @type {(inputs: Clubs_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun messaggio.`)
};

/**
* | output |
* | --- |
* | "No messages yet." |
*
* @param {Clubs_Chat_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_chat_empty = /** @type {((inputs?: Clubs_Chat_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Chat_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_chat_empty(inputs)
	if (locale === "es-419") return es_419_clubs_chat_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_chat_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_chat_empty(inputs)
	if (locale === "de-DE") return de_de2_clubs_chat_empty(inputs)
	if (locale === "it-IT") return it_it2_clubs_chat_empty(inputs)
	return en_us2_clubs_chat_empty(inputs)
});
export { clubs_chat_empty as "clubs.chat_empty" }